import type { SVGProps } from 'react';

export const LinkedIn = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 0a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h16ZM6.577 9.822a.116.116 0 0 0-.115.116v7.497c0 .063.052.115.115.115h2.346a.116.116 0 0 0 .115-.115V9.938a.116.116 0 0 0-.115-.116H6.577Zm8.385-.258c-.95 0-1.802.436-2.317 1.103v-.33a.517.517 0 0 0-.516-.515h-1.546a.516.516 0 0 0-.515.515v6.698c0 .283.232.515.515.515h1.546a.517.517 0 0 0 .516-.515V13.43a1.288 1.288 0 0 1 2.576 0v3.606c0 .283.231.515.514.515h1.546a.516.516 0 0 0 .515-.515v-4.379c0-2.06-1.412-3.092-2.834-3.092ZM7.75 5.701a1.546 1.546 0 1 0 0 3.092 1.546 1.546 0 0 0 0-3.092Z" />
    </svg>
  );
};
